import { NgModule } from '@angular/core';
import { STATES } from './checkout.states';
import { CheckoutComponent } from './checkout.component';
import { UIRouterModule } from '@uirouter/angular';
import { CheckoutService } from './checkout.service';
import { GlobalModule } from '../global/global.module';
import { CheckoutIndexComponent } from './index/index.component';
import { CheckoutPaymentComponent } from './payment/payment.component';
import { CheckoutRegisterComponent } from './register/register.component';
import { CheckoutSuccessComponent } from './success/success.component';
import { CheckoutInfoComponent } from './info/info.component';
import { CheckoutSliderComponent } from './slider/slider.component';
import { ApiModule } from '../api/api.module';
import { CheckoutSuccessVouchersComponent } from './successVouchers/successVouchers.component';
import { ReceiptWorthMappingService } from './receiptWorthMapping.service';

@NgModule({
  declarations: [
    CheckoutComponent,
    CheckoutIndexComponent,
    CheckoutPaymentComponent,
    CheckoutRegisterComponent,
    CheckoutSuccessComponent,
    CheckoutSuccessVouchersComponent,
    CheckoutSliderComponent,
    CheckoutInfoComponent
  ],
  imports: [
    GlobalModule,
    ApiModule,
    UIRouterModule.forChild({states: STATES})
  ],
  providers: [
    CheckoutService,
    ReceiptWorthMappingService
  ],
  exports: [
  ]
})
export class CheckoutModule {
}



// WEBPACK FOOTER //
// ./src/app/checkout/checkout.module.ts